module.exports = {
  // api key
  signUpApiKey: 'AAA-BBB-CCC-CCC',
  backEndBaseUrl: 'https://admin.t365.io',
  frontEndUrl: 'https://admin.t365.io',
  captchaSiteKey: "6LcbNXkUAAAAAGM_mQWMao2Inp87HUg6FMbBDJd0"
};
